export default class InfoItem {
    constructor(model) {
        this.id = (model && model.id) || null;
        this.internal = (model && model.internal) || null;
        this.identifier = (model && model.identifier) || null;
        this.title = (model && model.title) || {};
        this.summary = (model && model.summary) || {};
        this.text = (model && model.text) || {};
        this.textButton = (model && model.textButton) || {};
        this.objects = (model && model.objects) || [];
        this.objectIds = (this.objects && this.objects.map(object => object.id)) || [];
        this.application = (model && model.application) || null;
        this.published = (model && model.published) || false;
    }
}
